import { render, staticRenderFns } from "./RosterAiView.vue?vue&type=template&id=54c673a1&scoped=true"
import script from "./RosterAiView.vue?vue&type=script&lang=js"
export * from "./RosterAiView.vue?vue&type=script&lang=js"
import style0 from "./RosterAiView.vue?vue&type=style&index=0&id=54c673a1&prod&scoped=true&lang=css"
import style1 from "./RosterAiView.vue?vue&type=style&index=1&id=54c673a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c673a1",
  null
  
)

export default component.exports